import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcQrCodeSmallOl = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.5 3.25C1.5 2.2835 2.2835 1.5 3.25 1.5H7.5V3H3.25C3.11193 3 3 3.11193 3 3.25V7.5H1.5V3.25ZM22.5 20.75C22.5 21.7165 21.7165 22.5 20.75 22.5H16.5V21H20.75C20.8881 21 21 20.8881 21 20.75V16.5H22.5V20.75ZM22.5 3.25C22.5 2.2835 21.7165 1.5 20.75 1.5H16.5V3L20.75 3C20.8881 3 21 3.11193 21 3.25V7.5H22.5V3.25ZM3.25 22.5C2.2835 22.5 1.5 21.7165 1.5 20.75V16.5L3 16.5L3 20.75C3 20.8881 3.11193 21 3.25 21H7.5V22.5H3.25ZM11.25 5.25H5.25V11.25H11.25V5.25ZM6.75 9.75V6.75H9.75V9.75H6.75ZM5.25 12.75H11.25V18.75H5.25V12.75ZM6.75 14.25V17.25H9.75V14.25H6.75ZM15 12.75H12.75V15H15V16.5H12.75V18.75H15V16.5H16.5V18.75H18.75V16.5V15H15V12.75ZM18.75 5.25H12.75V11.25H18.75V5.25ZM14.25 9.75V6.75H17.25V9.75H14.25Z",
		fill: "inherit"
	})
});
export default SvgIcQrCodeSmallOl;
